const { getOffsetTop } = window.BAO.Utils

class SectionTimeline extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.setupSizes = this.setupSizes.bind(this)

    this.setupSizes()
    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScroll, { passive: true })

    this.debouncedOnResize = window.BAO.Utils.debounce(() => {
      this.setupSizes()
    }, 200)

    window.addEventListener('resize', this.debouncedOnResize)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveMedia()
  }

  setupSizes () {
    // Decreases height of scroll = faster horizontal scroll
    const modifier = window.BAO.MediaBreakpoints.isSm ? 1 : 0.75

    const roundedHeight = Math.round(this.mediaViewportPercent * modifier)

    this.style.setProperty(
      '--Media_Total',
      `${roundedHeight > 100 ? roundedHeight : 110}vh`,
    )

    const headerHeight = this.els.header.element.offsetHeight

    this.style.setProperty(
      '--Item_Height',
      `calc(100vh - ${headerHeight}px - (var(--Section_Margin) * 2))`,
    )
  }

  moveMedia () {
    const maxScrollAmount = this.mediaViewportPercent - 100

    const elementHeight = this.offsetHeight

    const elementStartPoint = getOffsetTop(this)
    const elementEndPoint =
      getOffsetTop(this) + elementHeight - window.innerHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.style.setProperty('--Scroll_Amount', `0vw`)

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.style.setProperty('--Scroll_Amount', `-${maxScrollAmount}vw`)

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const scrollAmount = maxScrollAmount * scrollYAsAPercentageOfJourney

    this.style.setProperty('--Scroll_Amount', `-${scrollAmount}vw`)
  }

  get mediaViewportPercent () {
    const mediaItemsWidth = this.els.item.elements.reduce(
      (accumulator, currentValue) => {
        return accumulator + currentValue.offsetWidth
      },
      0,
    )

    const mediaWidthViewportPercent =
      (mediaItemsWidth / window.innerWidth) * 100

    const headerHeight = this.els.header.element.offsetHeight

    const headerHeightViewportPercent =
      (headerHeight / window.innerWidth) * 100

    const marginOffset = (40 / window.innerWidth) * 100

    return (
      mediaWidthViewportPercent + headerHeightViewportPercent - marginOffset
    )
  }
}

if (!customElements.get('section-timeline')) {
  customElements.define('section-timeline', SectionTimeline)
}
